// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.br-theme-fontawesome-stars-o .br-widget {
  height: 28px;
  white-space: nowrap;
}
.br-theme-fontawesome-stars-o .br-widget a {
  font: normal normal normal 20px/1 FontAwesome;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  text-decoration: none;
  margin-right: 2px;
}
.br-theme-fontawesome-stars-o .br-widget a:after {
  content: '\\f006';
  color: #d2d2d2;
}
.br-theme-fontawesome-stars-o .br-widget a.br-active:after {
  content: '\\f005';
  color: #50E3C2;
}
.br-theme-fontawesome-stars-o .br-widget a.br-selected:after {
  content: '\\f005';
  color: #50E3C2;
}
.br-theme-fontawesome-stars-o .br-widget a.br-fractional:after {
  content: '\\f123';
  color: #50E3C2;
}
.br-theme-fontawesome-stars-o .br-widget .br-current-rating {
  display: none;
}
.br-theme-fontawesome-stars-o .br-readonly a {
  cursor: default;
}
.br-theme-fontawesome-stars-o .br-reverse a.br-fractional {
  display: inline-block;
  transform: scaleX(-1);
  -moz-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}
@media print {
  .br-theme-fontawesome-stars-o .br-widget a:after {
    content: '\\f006';
    color: black;
  }
  .br-theme-fontawesome-stars-o .br-widget a.br-active:after,
  .br-theme-fontawesome-stars-o .br-widget a.br-selected:after {
    content: '\\f005';
    color: black;
  }
  .br-theme-fontawesome-stars-o .br-widget a.br-fractional:after {
    content: '\\f123';
    color: black;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/jquery-bar-rating/dist/themes/fontawesome-stars-o.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,6CAA6C;EAC7C,oBAAoB;EACpB,mCAAmC;EACnC,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,0BAA0B;EAC1B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;;IAEE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;AACF","sourcesContent":[".br-theme-fontawesome-stars-o .br-widget {\n  height: 28px;\n  white-space: nowrap;\n}\n.br-theme-fontawesome-stars-o .br-widget a {\n  font: normal normal normal 20px/1 FontAwesome;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  text-decoration: none;\n  margin-right: 2px;\n}\n.br-theme-fontawesome-stars-o .br-widget a:after {\n  content: '\\f006';\n  color: #d2d2d2;\n}\n.br-theme-fontawesome-stars-o .br-widget a.br-active:after {\n  content: '\\f005';\n  color: #50E3C2;\n}\n.br-theme-fontawesome-stars-o .br-widget a.br-selected:after {\n  content: '\\f005';\n  color: #50E3C2;\n}\n.br-theme-fontawesome-stars-o .br-widget a.br-fractional:after {\n  content: '\\f123';\n  color: #50E3C2;\n}\n.br-theme-fontawesome-stars-o .br-widget .br-current-rating {\n  display: none;\n}\n.br-theme-fontawesome-stars-o .br-readonly a {\n  cursor: default;\n}\n.br-theme-fontawesome-stars-o .br-reverse a.br-fractional {\n  display: inline-block;\n  transform: scaleX(-1);\n  -moz-transform: scaleX(-1);\n  -webkit-transform: scaleX(-1);\n  filter: FlipH;\n  -ms-filter: \"FlipH\";\n}\n@media print {\n  .br-theme-fontawesome-stars-o .br-widget a:after {\n    content: '\\f006';\n    color: black;\n  }\n  .br-theme-fontawesome-stars-o .br-widget a.br-active:after,\n  .br-theme-fontawesome-stars-o .br-widget a.br-selected:after {\n    content: '\\f005';\n    color: black;\n  }\n  .br-theme-fontawesome-stars-o .br-widget a.br-fractional:after {\n    content: '\\f123';\n    color: black;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
